import { render } from "./App.vue?vue&type=template&id=2b53f18e"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2b53f18e&lang=less"
script.render = render

export default script